import React, { MutableRefObject, useCallback } from 'react';
import { AutoSizer } from 'react-virtualized';
import type { VariableSizeList as List } from 'react-window';
import type { TableInstance } from 'react-table';

import { VirtualListTableContainer } from 'bringg-web/components/bringg-react-table';
import type { ReactWindowRenderRowProp } from 'bringg-web/components/bringg-react-table';

interface RenderTableContainerProps<T extends Record<string, unknown>> extends ReactWindowRenderRowProp {
	tableInstance: TableInstance<T>;
}

const useRenderTableContainer = <T extends Record<string, unknown>>(
	listRef: MutableRefObject<List>,
	getItemSize: (index?: number) => number,
	isLoading?: boolean,
	headerHeight?: number
) => {
	// TODO: investigate how lambda which returns component affects reconciliation process
	return useCallback(
		({ RenderRow, tableInstance }: RenderTableContainerProps<T>) => (
			<AutoSizer disableWidth>
				{({ height }) => (
					<VirtualListTableContainer<T>
						listRef={listRef}
						isLoading={isLoading}
						height={height}
						headerHeight={headerHeight}
						getItemSize={getItemSize}
						tableInstance={tableInstance}
						RenderRow={RenderRow}
					/>
				)}
			</AutoSizer>
		),
		[listRef, headerHeight, isLoading, getItemSize]
	);
};

export default useRenderTableContainer;
